import { Divider, Grid, Typography } from "@mui/material";
import EnableWeekends from "./EnableWeekends";
import { find, remove, startCase } from "lodash";
import React, { useContext } from "react";
import DefaultCurrency from "./DefaultCurrency";
import ProjectShifts from "./ProjectShifts";
import { ProjectKickOffs, ProjectSettingsCreate } from "@/graphql/generated/graphql";
import { ProjectContext } from "@/Contexts/Project/Context";
import CircularLoader from "../Loaders/CircularLoader";

interface MultipleSettingsFormProps {
  showHeading?: boolean;
  settings: ProjectSettingsCreate[];
  onSettingsChange: (settings: ProjectSettingsCreate[]) => void;
}

// ! This is a temporary patch, projectData should be coming from actual kick-off later
const projectData = {} as ProjectKickOffs['data']

const MultipleSettingsForm: React.FC<MultipleSettingsFormProps> = ({ showHeading = true, settings, onSettingsChange }) => {
  const { loadingProject, defaultCompanySettings } = useContext(ProjectContext);
  const predefinedEnableWeekends = find(projectData?.projectDetails?.projectSettings, (setting) => setting.name === "enable-weekends")?.value;
  const predefinedShifts = find(projectData?.projectDetails?.projectSettings, (setting) => setting.name === "project-shifts")?.value;
  const shouldShiftsBeToggled = () => {
    const storedShifts = find(settings, s => s.name === "project-shifts");

    if (storedShifts) {
      return storedShifts?.value !== "";
    } else {
      return Boolean(predefinedShifts);
    }
  }

  const handleUpdate = (settingName: string, settingValue: string) => {
    const oldSettings = [...settings]
    remove(oldSettings, (s => s.name === settingName));

    onSettingsChange([...oldSettings, { name: settingName, value: settingValue }]);
  };

  if (loadingProject) return <CircularLoader />

  return (
    <React.Fragment>
      {showHeading &&
        <Divider sx={{ mt: 3 }}>
          <Typography component="h1" variant="h5" sx={{ textAlign: "center" }}>
            Project Settings (Optional)
          </Typography>
          <Typography align="center" component='h1' variant='caption'>
            Add custom settings for this project
          </Typography>
        </Divider>
      }
      <Grid container direction="column" spacing={2}>
        <EnableWeekends
          settingName={startCase("enable-weekends")}
          settingValue={find(settings, s => s.name === "enable-weekends")?.value || predefinedEnableWeekends || defaultCompanySettings.enableWeekends}
          handleUpdate={(settingValue) => handleUpdate('enable-weekends', settingValue)}
        />

        <ProjectShifts
          settingName={startCase("project-shifts")}
          settingValue={find(settings, s => s.name === "project-shifts")?.value || defaultCompanySettings.companyWorkShifts}
          handleUpdate={(settingValue) => handleUpdate('project-shifts', settingValue)}
          defaultChecked={shouldShiftsBeToggled()}
        />

        <DefaultCurrency
          settingName={startCase("default-currency")}
          settingValue={find(settings, s => s.name === "default-currency")?.value || predefinedEnableWeekends || defaultCompanySettings.companyDefaultCurrency}
          handleUpdate={(settingValue) => handleUpdate('default-currency', settingValue)}
        />
      </Grid>
    </React.Fragment>
  );
};

export default MultipleSettingsForm;
